import Validate from 'components/hoc/Validate';
import { Validator } from 'components/hoc/Validate/Validate';
import RotationDirections from 'components/Icons/RotationDirections';
import ValidatableInput from 'components/inputs/ValidatableInput';
import React from 'react';
import { IsNotEmpty, IsNumeric } from 'utils/Validate';

type AlignRotationProps = {
  rotateSheet: (direction: string) => () => void;
  rotateSheetInput: (degrees: string) => void;
  sheetBearing: string;
};

const AlignRotation: React.FC<AlignRotationProps> = ({
  rotateSheet,
  rotateSheetInput,
  sheetBearing,
}: AlignRotationProps) => {
  const rotationInputValidations: Validator[] = [
    {
      name: 'required',
      message: 'A value is required',
      test: (value: string): boolean => {
        return IsNotEmpty(value);
      },
    },
    {
      name: 'number',
      message: 'The value must be a number or fraction',
      test: (value: string): boolean => {
        return IsNumeric(value);
      },
    },
  ];

  return (
    <div
      className="pos-a flex row hrem-2p75 justify-center"
      style={{
        alignItems: 'center',
        backgroundColor: 'white',
        borderRadius: '3px',
        bottom: '32px',
        cursor: 'pointer',
        right: '16px',
        width: '160px',
      }}
    >
      <button
        style={{
          backgroundColor: 'white',
          borderRadius: '0 4px 4px 0',
          borderWidth: 0,
          cursor: 'pointer',
          outline: 'none',
        }}
        onClick={rotateSheet('left')}
      >
        <RotationDirections rotation="LEFT" />
      </button>
      <Validate validators={rotationInputValidations}>
        {({
          valid,
          onBlur,
          onFocus,
          onChange,
          onLoad,
          tested,
        }): React.ReactNode => (
          <ValidatableInput
            id="sheet-rotation-input"
            isValid={valid}
            onBlur={(event) => {
              rotateSheetInput(event.target.value);
              onBlur(event);
            }}
            onFocus={onFocus}
            onChange={(event) => {
              rotateSheetInput(event.target.value.trim());
              onChange(event);
            }}
            onInputLoad={onLoad}
            tested={tested}
            style={{
              height: '32px',
              marginLeft: '10px',
              marginRight: '10px',
              padding: '1px',
              textAlign: 'center',
              width: '60px',
            }}
            value={sheetBearing}
          />
        )}
      </Validate>
      <button
        style={{
          backgroundColor: 'white',
          borderRadius: '0 4px 4px 0',
          borderWidth: 0,
          cursor: 'pointer',
          outline: 'none',
        }}
        onClick={rotateSheet('right')}
      >
        <RotationDirections rotation="RIGHT" />
      </button>
    </div>
  );
};

export default AlignRotation;
